<div class="" style="position: relative;">
<div class="d-flex align-items-center ie-d-block" style="position: relative;">
    <img src="/assets/images/contact-us-banner.jpg" alt="banner" usemap="#workmap" class="img-fluid">

    <div class="masthead">
      <div class="container">
        <h1 class="font-weight-light">Contact Us</h1>
      </div>
    </div>

   
          
    <map name="workmap">
      <!-- <area shape="rect" coords="34,44,270,350" alt="Computer" href="https://www.google.com/">
      <area shape="rect" coords="290,172,333,250" alt="Phone" href="https://www.facebook.com/"> -->
      <!-- <area coords="600,44,200" alt="Cup of coffee" href="https://www.youtube.com/">
      <area coords="955,640,328,30" alt="Cup of coffee" href="https://www.facebook.com/">
      <area coords="267,180,323,179" alt="Cup of coffee" href="https://www.google.com/"> -->

    </map>


</div>

  <a routerLink="/sweden" class="sweden-link">Sweden</a>

  <a routerLink="/norway" class="norway-link">Norway</a>

  <a routerLink="/denmark" class="denmark-link">Denmark</a>

  <a routerLink="/finland" class="finland-link">Finland</a>

  <a routerLink="/estonia" class="estonia-link">Estonia</a>
</div>





